import { ACCOUNT_PAGE } from 'hooks/usePageRoutes/constants';

export const ACCOUNT_EDIT_ROUTE = `${ACCOUNT_PAGE}/edit`;

export const ACCOUNT_NEW_ROUTE = `${ACCOUNT_PAGE}/new`;

export const EDIT_PANEL_ROUTE_PREFIXES = [ACCOUNT_EDIT_ROUTE, ACCOUNT_NEW_ROUTE];

export const getIsEditPanelOpen = (pathname: string): boolean =>
    EDIT_PANEL_ROUTE_PREFIXES.some(routePrefix => pathname.startsWith(routePrefix));
